import $ from 'jquery';
import { Component, ElementRef, Input, HostListener, OnChanges } from '@angular/core';

@Component({
  selector: 'long-text',
  templateUrl: './long-text.component.html',
  styleUrls: ['./long-text.component.scss'],
})
export class LongTextComponent implements OnChanges {
  @Input() public text;
  private $el;
  private $popup;

  constructor(elRef: ElementRef) {
    this.$el = $(elRef.nativeElement);
    this.text = this.text || null;
  }

  public ngOnChanges() {
    this.$el.find('.text').text(this.text);
    this.togglePopup();
  }

  @HostListener('window:resize')
  public togglePopup() {
    const $text = this.$el.find('.text');
    if ($text[0].scrollWidth > Math.ceil($text.innerWidth())) {
      const $popup = this.$popup = this.$el.find('.ui.popup').text(this.text);
      this.$el.popup({
        popup: $popup,
        inline: true,
        position: 'bottom center',
        setFluidWidth: true,
      });
    } else if (this.$popup) {
      this.$el.popup('destroy');
      this.$popup = null;
    }
  }
}
